(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    



document.addEventListener('DOMContentLoaded', function() {
  document.querySelector('.trigger_cart').addEventListener('click', function() {
    document.querySelector('.trigger_cart_here').click();
  });
});



  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-after-before-people"] && !Shopify.designMode) return;
  try {
    


const nwrpSlider = new Swiper('.nw-rp-slider', {
  slidesPerView: 1,
  spaceBetween: 0,
  centeredSlides: false,
  speed: 800,
  loop: false,
  spaceBetween: 24,
  scrollbar: {
    el: '.nw-rp-slider .swiper-scrollbar',
    draggable: true,
  },
  breakpoints: {
    750: {
        slidesPerView: 3,
        scrollbar: false,
    },
  },
});
    
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-experts"] && !Shopify.designMode) return;
  try {
    

const SwiperThumb = new Swiper('.swiper-small-thumb', {
    spaceBetween: 11,
    slidesPerView: 'auto',
  });
  const swiperMain = new Swiper('.NWexpertsSlider', {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: true,
    speed: 800,
    loop: false,
    spaceBetween: 20,
    navigation: {
      nextEl: '.NWexpertsSlider .swiper-button-next',
      prevEl: '.NWexpertsSlider .swiper-button-prev',
    },
    thumbs: {
      swiper: SwiperThumb,
    },
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-research"] && !Shopify.designMode) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  function startCounterAnimation() {
    const counters = document.querySelectorAll(".percentage-text span");

    counters.forEach((counter) => {
      counter.innerText = "0";

      const updateCounter = () => {
        const target = +counter.getAttribute("data-target");
        const c = +counter.innerText;
        const increment = target / 200;

        if (c < target) {
          counter.innerText = `${Math.ceil(c + increment)}`;
          setTimeout(updateCounter, 10);
        } else {
          counter.innerText = target;
        }
      };

      updateCounter();
    });
  }

  startCounterAnimation();

  document.addEventListener("shopify:section:load", startCounterAnimation);
  document.addEventListener("shopify:section:reorder", startCounterAnimation);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-symptoms"] && !Shopify.designMode) return;
  try {
    
  const NWsymptomsSlider = new Swiper('.NWsymptomsSlider', {
      spaceBetween: 24,
      loop: false,
      scrollbar: {
        el: '.NWsymptomsSlider .swiper-scrollbar',
        draggable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 2.2,
          spaceBetween: 22,
          centeredSlides: false,
          grabCursor: true,
        },
        640: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      },
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-transformations"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.video-play-button').forEach(button => {
    button.addEventListener('click', function() {
        const video = this.previousElementSibling;
        if (video.paused) {
            video.play();
            video.classList.add('playing');
        } else {
            video.pause();
            video.classList.remove('playing');
        }
    });
});

document.querySelectorAll('.video-volume-button').forEach(button => {
    button.addEventListener('click', function() {
        const video = this.previousElementSibling.previousElementSibling;
        video.muted = !video.muted;
        this.querySelector('svg').classList.toggle('muted', video.muted);
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nw-yourself-slider"] && !Shopify.designMode) return;
  try {
    
const NWCategorySlider = new Swiper('.NWYourselfSlider', {
  slidesPerView: 1,
  spaceBetween: 0,
  centeredSlides: true,
  speed: 800,
  loop: true,
  spaceBetween: 20,
  navigation: {
    nextEl: '.NWYourselfSlider .swiper-button-next',
    prevEl: '.NWYourselfSlider .swiper-button-prev',
  },
  scrollbar: {
    el: '.NWYourselfSlider .swiper-scrollbar',
    draggable: true,
  },
  breakpoints: {
    750: {
      scrollbar: false,
    },
  },
});



  } catch(e) { console.error(e); }
})();
})();
